import React from "react";
import { Box, Card, CardContent, CardMedia, Badge } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import withStyles from "isomorphic-style-loader/withStyles";
import PrimaryButton from "../../../../../../../toolkit/primaryButton";
import s from "./styles.scss";

interface NavigationCardProps {
  title: string;
  description?: string;
  image?: string;
  imageAlt?: string;
  icon?: React.ReactNode;
  onClick?: () => void;
  isCompleted?: boolean;
}

const NavigationCard: React.FC<NavigationCardProps> = ({
  title,
  description,
  image,
  imageAlt,
  icon,
  onClick,
  isCompleted = false,
}) => {
  return (
    <Badge
      badgeContent={
        isCompleted ? (
          <CheckCircleIcon
            sx={{
              color: "#4caf50",
              fontSize: 28,
              backgroundColor: "white",
              borderRadius: "50%",
            }}
          />
        ) : null
      }
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      sx={{
        "& .MuiBadge-badge": {
          right: 10,
          top: 10,
          padding: 0,
          minWidth: "auto",
          height: "auto",
          backgroundColor: "transparent",
        },
      }}
    >
      <Card
        sx={{
          width: 250,
          height: 300,
          display: "flex",
          flexDirection: "column",
          borderRadius: "10px",
          border: isCompleted ? "2px solid #4caf50" : "1px solid #E2E8F0",
          transition:
            "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out, border-color 0.3s ease",
          backgroundColor: isCompleted ? "#f1f8e9" : "white",
          "&:hover": {
            transform: "scale(1.02)",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          },
        }}
      >
        {icon ? (
          <Box
            sx={{
              alignItems: "center",
              boxSizing: "border-box",
              color: "#94a3b8",
              display: "flex",
              flexShrink: 0,
              height: 120,
              justifyContent: "center",
              width: "100%",
              "& svg": {
                display: "block",
                fontSize: "100px",
                height: "100px",
                width: "100px",
              },
            }}
          >
            {icon}
          </Box>
        ) : (
          <CardMedia
            component="img"
            width="100%"
            height="120"
            image={image}
            alt={imageAlt || title}
            sx={{
              objectFit: "contain",
              padding: "12px 16px 0 16px",
              flexShrink: 0,
            }}
          />
        )}
        <CardContent
          sx={{
            display: "flex",
            flex: 1,
            flexDirection: "column",
            pb: "16px !important",
            pt: 1,
            textAlign: "center",
          }}
        >
          <h3 className={s.cardTitle}>{title}</h3>
          {description && <p className={s.cardDescription}>{description}</p>}
          <div className={s.cardActionRow}>
            <PrimaryButton
              variant={isCompleted ? "primary" : "secondary"}
              className={s.startButton}
              onClick={onClick}
            >
              {isCompleted ? "Edit" : "Customize"}
            </PrimaryButton>
          </div>
        </CardContent>
      </Card>
    </Badge>
  );
};

export default withStyles(s)(NavigationCard);
